import Loader from '@/components/common/loader';
import getUserInfo from '@/fetches/user/user-profile/get-user-profile';
import useAlert from '@/hooks/use-alert';
import useSelectorUser from '@/hooks/use-selector-user';
import { useTranslation } from 'react-i18next';
import Message from '@/constant/message';
import { actions } from '@/store';
import TokenManager from '@/utils/token-manager';
import React, { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { hideAuthModal } from '../..';

/** 로그인 성공 */
export const Success: React.FC = () => {
  const { onSuccess, token } = useSelectorUser('authModal');
  const dispatch = useDispatch();
  const { alert } = useAlert();
  const { t } = useTranslation();

  const endLogin = useCallback(async () => {
    try {
      TokenManager.setToken(token);
      const userInfo = await getUserInfo();
      hideAuthModal();
      if (onSuccess) onSuccess();
      if (userInfo) {
        dispatch(actions.common.userInfo.setProfile(userInfo));
        dispatch(actions.user.authModal.init());
      } else {
        throw new Error();
      }
    } catch (e) {
      await alert(t(Message.알수없는이유로로그인을실패하였습니다));
      dispatch(actions.user.authModal.init());
    }
  }, [alert, dispatch, onSuccess, token, t]);

  useEffect(() => {
    endLogin();
  }, [endLogin]);

  return (
    <>
      <Loader />
    </>
  );
};
